/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Pump_Send_ErrorInputs */

const vi_irrigation_pump_send_error = /** @type {(inputs: Irrigation_Pump_Send_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi lệnh bật/tắt bơm thất bại`)
};

/**

* @param {Irrigation_Pump_Send_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_send_error = /** @type {((inputs?: Irrigation_Pump_Send_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Send_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_send_error(inputs)
});